import React from "react";
import { cn, formatCurrency, formatNumber, formatPercent } from "../../lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export function KPICard({
  title,
  value,
  change,
  changeLabel,
  icon: Icon,
  format = "currency",
  className,
}) {
  const formattedValue = () => {
    switch (format) {
      case "currency":
        return formatCurrency(value);
      case "number":
        return formatNumber(value);
      case "percent":
        return formatPercent(value);
      default:
        return value;
    }
  };

  const isPositive = change > 0;

  return (
    <div className={cn("kpi-card", className)} data-testid={`kpi-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="kpi-label mb-1">{title}</p>
          <p className="kpi-value">{formattedValue()}</p>
        </div>
        {Icon && (
          <div className="p-2 rounded-sm bg-accent/10">
            <Icon className="h-5 w-5 text-accent" />
          </div>
        )}
      </div>
      {change !== undefined && (
        <div className="mt-3 flex items-center gap-1">
          {isPositive ? (
            <TrendingUp className="h-4 w-4 text-green-600" />
          ) : (
            <TrendingDown className="h-4 w-4 text-red-600" />
          )}
          <span className={cn("kpi-change", isPositive ? "positive" : "negative")}>
            {isPositive ? "+" : ""}{change.toFixed(1)}%
          </span>
          {changeLabel && (
            <span className="text-xs text-muted-foreground ml-1">{changeLabel}</span>
          )}
        </div>
      )}
    </div>
  );
}
